import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { workspaceRuntime } from '#layers/runtime/public';
import { keepsWorkspaceRuntime } from '~/utils/routes';
import { useWorkspaceSwitch } from '~/workspace/use-workspace-switch';

export default defineNuxtRouteMiddleware((to) => {
	if (keepsWorkspaceRuntime(to)) return;

	if (workspaceRuntime.state.value.phase === 'idle') return;

	useWorkspaceSwitch().leave();
});
